import DocumentRepository from "../Repository/DocumentRepository";
import Document from "../Entity/Document";

export default class ChangeDocumentPosition {
    public constructor(
        private readonly documentRepository: DocumentRepository
    ) {
    }

    public change(id: string, position: number): void {
        const document: Document | null = this.documentRepository.getById(id);
        if (null === document) {
            return;
        }

        document.setPosition(position);
        this.documentRepository.save(document);
    }
}